import React from 'react';
import { useHistory, useParams } from 'react-router-dom';

interface URLTabsResult {
  tabValue: number;
  handleTabChange: (event: React.SyntheticEvent, newValue: number) => void;
}

const URLTabs = (tabNames: string[], baseUrl: string): URLTabsResult => {
  const history = useHistory();
  const { tab } = useParams<Record<string, string>>();
  const [tabValue, setTabValue] = React.useState(0);

  const getTabNameByIndex = (index: number): string => {
    return tabNames[index] || tabNames[0];
  };

  const getTabIndexByName = (name: string): number => {
    return tabNames.indexOf(name);
  };

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number): void => {
    setTabValue(newValue);
    const tabName = getTabNameByIndex(newValue);
    history.push(`${baseUrl}/${tabName}`);
  };

  React.useEffect(() => {
    const tabIndex = getTabIndexByName(tab);
    if (tabIndex !== -1) {
      setTabValue(tabIndex);
    }
  }, [tab]);

  return { tabValue, handleTabChange };
};

export default URLTabs;
